// detected user agent 

export const detectedUserAgent = () => {
    const userAgent = navigator
        .userAgent
        .toLowerCase();
    if (userAgent.match(/Android/i)) {
        return 'android';
    }
    if (userAgent.match(/iPhone|iPad|iPod/i)) {
        return 'ios';
    }
}